<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" :width="width" :height="height"><g stroke-linecap="square" stroke-linejoin="miter" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><path d="M27,14V28a3,3,0,0,1-3,3H8a3,3,0,0,1-3-3V14" fill="none" stroke-miterlimit="10" :stroke="fill" /> <line x1="16" y1="16" x2="16" y2="25" fill="none" stroke-miterlimit="10" /> <line x1="11" y1="16" x2="11" y2="25" fill="none" stroke-miterlimit="10" /> <line x1="21" y1="16" x2="21" y2="25" fill="none" stroke-miterlimit="10" /> <polyline points="11 6 11 1 21 1 21 6" fill="none" stroke-miterlimit="10" stroke-linecap="butt" :stroke="fill" /> <rect x="2" y="6" width="28" height="4" fill="none" stroke-miterlimit="10" :stroke="fill" /></g></svg>
</template>

<script>
	export default {
		props: {
			width: {
				type: [
					Number,
					String
				],
				default: '100%'
			},
			height: {
				type: [
					Number,
					String
				],
				default: '100%'
			},
			strokewidth: {
				type: [
					Number,
					String
				],
				default: 1
			},
			fill: {
				type: String,
				default: 'currentColor'
			},
			secondaryfill: {
				type: String
			}
		},
		computed: {
			_secondaryfill() {
				return this.secondaryfill || this.fill;
			}
		}
	};
</script>